// extracted by mini-css-extract-plugin
module.exports = {"nav_box":"nav_box-3-eLvNir","main_nav":"main_nav-xJj1hHer","userinfo":"userinfo-2q5s4-57","ad":"ad-dQtbcbJK"};